export default "__VITE_ASSET__BO2j78tR__"